import React from 'react';
import { Tabs } from './LessonResources';

type Props = {
  name: Tabs,
  currentTab: Tabs,
  handleSelect: (name: Tabs) => void,
}

const LessonResourceSingleTabItem: React.FunctionComponent<Props> = ({ name, currentTab, handleSelect, children }) => (
  <div
      className={currentTab === name ? 'selected': ''}
      onClick={() => handleSelect(name)}
    >
    {children}
  </div>
);

export default LessonResourceSingleTabItem;
